<template>
    <div class="auth-layout mt-12">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: 'AuthLayout'
}
</script>